import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// New structured locale files (Fase 1+)
import esCommon from "./locales/es/common.json";
import itCommon from "./locales/it/common.json";
import enCommon from "./locales/en/common.json";
import ptCommon from "./locales/pt/common.json";
import esTickets from "./locales/es/tickets.json";
import itTickets from "./locales/it/tickets.json";
import enTickets from "./locales/en/tickets.json";
import ptTickets from "./locales/pt/tickets.json";
import esContacts from "./locales/es/contacts.json";
import itContacts from "./locales/it/contacts.json";
import enContacts from "./locales/en/contacts.json";
import ptContacts from "./locales/pt/contacts.json";
import esQueues from "./locales/es/queues.json";
import itQueues from "./locales/it/queues.json";
import enQueues from "./locales/en/queues.json";
import ptQueues from "./locales/pt/queues.json";
import esPendientes from "./locales/es/pendientes.json";
import itPendientes from "./locales/it/pendientes.json";
import enPendientes from "./locales/en/pendientes.json";
import ptPendientes from "./locales/pt/pendientes.json";
import esTurnos from "./locales/es/turnos.json";
import itTurnos from "./locales/it/turnos.json";
import enTurnos from "./locales/en/turnos.json";
import ptTurnos from "./locales/pt/turnos.json";

// Legacy translations — importing here ensures this init runs before
// translate/i18n.js and includes all existing strings
import { messages as legacyMessages } from "./translate/languages";

// FEATURE FLAG: when true, i18n.changeLanguage() is called from SettingsContext
// with the tenant's configured language. Keep false until validated in production.
export const I18N_TENANT_DETECTION_ENABLED = true;

const resources = {
  es: {
    translations: legacyMessages.es?.translations || {},
    common: esCommon,
    tickets: esTickets,
    contacts: esContacts,
    queues: esQueues,
    pendientes: esPendientes,
    turnos: esTurnos,
  },
  it: {
    translations: legacyMessages.it?.translations || {},
    common: itCommon,
    tickets: itTickets,
    contacts: itContacts,
    queues: itQueues,
    pendientes: itPendientes,
    turnos: itTurnos,
  },
  en: {
    translations: legacyMessages.en?.translations || {},
    common: enCommon,
    tickets: enTickets,
    contacts: enContacts,
    queues: enQueues,
    pendientes: enPendientes,
    turnos: enTurnos,
  },
  pt: {
    translations: legacyMessages.pt?.translations || {},
    common: ptCommon,
    tickets: ptTickets,
    contacts: ptContacts,
    queues: ptQueues,
    pendientes: ptPendientes,
    turnos: ptTurnos,
  },
};

export const initI18n = (language = "es") => {
  try {
    if (!i18n.isInitialized) {
      i18n
        .use(initReactI18next)
        .init({
          resources,
          lng: I18N_TENANT_DETECTION_ENABLED ? language : "es",
          fallbackLng: "es",
          defaultNS: "translations",
          ns: ["translations", "common", "tickets", "contacts", "queues", "pendientes", "turnos"],
          interpolation: { escapeValue: false },
          react: { useSuspense: false },
        });
    }
  } catch (error) {
    console.warn("[i18n] Error al inicializar, usando fallback español:", error);
    if (!i18n.isInitialized) {
      i18n.use(initReactI18next).init({
        resources: { es: { translations: legacyMessages.es?.translations || {}, common: esCommon } },
        lng: "es",
        fallbackLng: "es",
        defaultNS: "translations",
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
      });
    }
  }
};

export default i18n;
